module.exports = __webpack_public_path__ + "img/bull.46bc6732.jpg";